import { ModelSagres } from "@/types/model-sagres";

export class LoginData extends ModelSagres {
  codigoUg?: string;
  cpf: string;
  email?: string;
  idUsuario?: string | number;
  nextStep: string; // 'index', 'reativar-usuario', 'confirmar-contato', 'trocar-senha'
  nomeGestor?: string;
  nomeUsuario: string;
  permissoes: string[]; // '/perfil', '/inicio' etc
  primeiroAcesso: string; // S/N
  situacao?: string; // 'entregue', 'pendente dados', 'pendente validacao'
  termosPendentes: any[];
  token: string;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.codigoUg = obj.codigoUg ?? undefined;
      this.cpf = obj.cpf;
      if (obj.email) this.email = obj.email;
      this.idUsuario = obj.idUsuario ?? obj.ID_USUARIO ?? obj.IdUsuario ?? undefined;
      this.nextStep = obj.nextStep;
      this.nomeGestor = obj.nomeGestor ?? undefined;
      this.nomeUsuario = obj.nomeUsuario;
      this.permissoes = obj.permissoes;
      this.primeiroAcesso = obj.primeiroAcesso;
      this.situacao = obj.situacao ?? undefined;
      this.termosPendentes = obj.termosPendentes;
      this.token = obj.token;
    }
  }
}
